<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss"></style>
<script>
import "@/assets/scss/app.scss";
import "@/assets/updata.config.js";

// import firebase from "firebase/app";
// import "firebase/messaging";

export default {
  name: "App",
  data() {
    return {
      imageOnerror: "/img/image_onerror.jpg"
    };
  },
  methods: {},
  mounted() {
    window.addEventListener("offline", () => {
      this.$bvToast.toast(
        "部分功能將無法使用，請檢查您的網路連線，並再試一次",
        {
          title: `您現在處於離線狀態`,
          toaster: "b-toaster-top-center",
          solid: true,
          appendToast: false,
          variant: "cms_main"
        }
      );
    });
    this.$nextTick(() => {
      var imgList = document.querySelectorAll("img");
      Array.prototype.forEach.call(imgList, item => {
        item.onerror = () => {
          item.src = this.imageOnerror;
        };
      });
    });

    // firebase.initializeApp({
    //   apiKey: "AIzaSyAQeWV_I_QoovRTM_QbWG2Q-xLih4Supmo",
    //   authDomain: "quartercar-e81b9.firebaseapp.com",
    //   projectId: "quartercar-e81b9",
    //   storageBucket: "quartercar-e81b9.appspot.com",
    //   messagingSenderId: "317586180683",
    //   appId: "1:317586180683:web:5c219811e071395ad0dbce",
    //   measurementId: "G-WHNZ0E6WRP"
    // });

    // const messaging = firebase.messaging();
    // messaging.onMessage(payload => {
    //   console.log("Message received. ", payload);
    //   // ...
    // });
    // window.addEventListener("load", function() {

    //   if ("serviceWorker" in navigator) {
    //     firebase.initializeApp(config);
    //     const messaging = firebase.messaging();
    //     messaging.getToken({
    //       vapidKey:
    //         "BMXtBODjpCBEreeLmhkmuc0lqt2RVdQBfXg2Uvm_Bb3ce25dQPt1WbL2lNoZyUjFJQE84Z2kkwSiMbJmp8WK-lU"
    //     });
    //     navigator.serviceWorker
    //       .register("/sw.js")
    //       .then(function(reg) {
    //         messaging.useServiceWorker(reg);
    //       })
    //       // 註冊失敗
    //       .catch(function(err) {
    //         console.log("error: ", err);
    //       });
    //   }

    //   messaging
    //     .requestPermission()
    //     .then(function() {
    //       // 先判斷localStorage有沒有token，沒有再取token
    //       var ckv = localStorage.getItem("augustusWsPush") || null;

    //       // cookies不存在，跟使用者要求通知權限
    //       if (ckv === null) {
    //         // 拿到token，firebase-messaging-sw.js 就會存 Service Workers 裡
    //         messaging.getToken().then(function(currentToken) {
    //           // token存至firebase
    //           var id = currentToken.split(":")[0];
    //           firebase
    //             .database()
    //             .ref("pushUsers/" + id)
    //             .set({ token: currentToken });

    //           // token存至localStorage
    //           localStorage.setItem("augustusWsPush", currentToken);
    //         });
    //       }
    //       // localStorage 已存在，從 localStorage 取出後傳至 firebase
    //       else {
    //         var id = ckv.split(":")[0];
    //         firebase
    //           .database()
    //           .ref("pushUsers/" + id)
    //           .set({ token: ckv });
    //       }
    //     })
    //     .catch(function(err) {
    //       console.log("使用者未允許通知", err);
    //     });
    //   // 附上刪除sw.js的寫法
    //   // navigator.serviceWorker.getRegistrations().then(function(reg) {
    //   //   for (var reg of reg) {
    //   //     reg.unregister();
    //   //   }
    //   // });
    // });
  }
};
</script>
